(function () {
    let wishListApi,
        external_id,
        customer_id,
        wishList,
        wishedProduct,
        notBuyableText,
        lastListProduct;

    function wishlistInit() {
        wishListApi = document.getElementById("wishListApi").value;
        external_id = document.getElementById('externalID').value;
        customer_id = parseInt(document.getElementById('customerId').value);
        wishList = document.getElementById("wish-list");
        wishedProduct = wishList.getElementsByTagName("li");
        notBuyableText = 'Ei saatavilla';
        contentLoading = document.getElementById('contentLoading');

        // add click event listener and check availability
        for (let i = 0; i < wishedProduct.length; ++i) {
            if(i === wishedProduct.length - 1) {
                lastListProduct = true;
            } 
            wishedProduct[i].getElementsByClassName('remove-from-list')[0].addEventListener("click", deleteFromWishList);
            wishedProduct[i].getElementsByClassName('wished-product-to-cart')[0].addEventListener("click", addToCart);
            let productHandle = wishedProduct[i].getElementsByClassName('wished-product-to-cart')[0].dataset.productHandle;
            let button = wishedProduct[i].getElementsByClassName('wished-product-to-cart')[0];
            checkAvailability(wishedProduct[i], productHandle, button, lastListProduct);
        }
    }

    function checkAvailability(itemElement, productHandle, button, lastListProduct) {
        let productUrl = window.location.origin + '/products/' + productHandle;
        $.ajax({
            type: 'GET',
            url: productUrl,
            dataType: 'html',
            success: function(html) {
                const authorElement =  $(html).find('span.author:first');
                const author = authorElement.text();
                const priceElement = $(html).find('[data-product-price]:first');
                const price = priceElement.text();
                const comparePriceElement = $(html).find('[data-compare-price]:first');
                const comparePrice = comparePriceElement.text();
                const typeElement = $(html).find('.type:first');
                const productType = typeElement.text();
                const imageElement = $(html).find('.the-image:first');
                const image = imageElement.attr('src').replace(/(\?|\&)width=\d+/g, '$1width=150');
                
                if (typeof author === 'string' && author.length > 0) {
                    $(itemElement).find('.author').text(author).removeClass("hidden");
                }

                if (typeof price === 'string' && price.length > 0) {
                    $(itemElement).find('.price').text(price).removeClass("hidden");
                    if (typeof comparePrice === 'string' && comparePrice.length > 0 && comparePrice.trim() !== price.trim() ) {
                        $(itemElement).find('.price').append('<s class="round-5">' + comparePrice + '</s>');
                    }
                }

                if (typeof productType === 'string' && productType.length > 0) {
                    $(itemElement).find('.type').text(productType).removeClass("hidden");
                }

                if (typeof image === 'string' && image.length > 0) {
                    const imgElement = $(itemElement).find('.wish-product-img img');
                    imgElement.attr('src', image);                   
                }               

                let productCta = $(html).find('.button.add-to-cart');
                if (productCta.length) {
                    productCta = productCta[0];
                    button.innerHTML = productCta.innerText.trim();
                    if (productCta.disabled) {
                        button.disabled = true;
                    }
                }
                itemElement.classList.add("loaded");
            },
           
            error: function(XMLHttpRequest, textStatus) {
                //disable cta
                button.innerHTML = notBuyableText;
                button.disabled = true;
                itemElement.classList.add("loaded");
            }
        });
    }


    function deleteFromWishList(event) {
        let product_id = event.target.closest(".remove-from-list").dataset.productId,
            parentElement = event.target.closest(".wish-product"),
            button = event.target.closest(".remove-from-list"),
            postData = {
                external_id: external_id,  
                customer_id: customer_id,
                product_id: product_id
            };
        button.disabled = true; 
        sendDeleteRequest(postData, parentElement, button);
    }
    
    function sendDeleteRequest( requestData, element, button ) {
        let request = new XMLHttpRequest();
        let url = wishListApi;
        request.open('DELETE', url);
        request.onload = function() {
            let res = JSON.parse(this.response);
            if (this.status == 200) {                
                element.classList.add("remove-product");
                setTimeout(function(){ element.remove(); }, 500);
                if (wishedProduct.length == 0) {
                    document.getElementById("emptyMessage").classList.remove("hidden");
                }
            } else { 
                button.disabled = false;                
            }
        };
        request.onerror = function() {
            // show some error log
        };
        let requestObj = {data: requestData};
        let postData = JSON.stringify(requestObj);
        request.setRequestHeader('Content-type', 'application/json; charset=utf-8');
        request.send(postData);
    }

    function addToCart(event) { 
        let elementId = event.target.dataset.productId;
        let button =  event.target; 
        button.disabled = true;
    
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: 
          {
            items:
            [
                {
                    id: elementId,
                    quantity: 1
                }
            ]
          },
          dataType: 'json',
          success: function(response) {
            woolman.getAndBuildCart();
            setTimeout(function(){ $cart.foundation('open'); }, 500);
            button.disabled = false;            
          },
          error: function(response) {            
            button.disabled = false;
          }
        });
    }

    if (document.readyState === "complete" || document.readyState === "loaded") {
        wishlistInit();
    } else {
        document.addEventListener("DOMContentLoaded", wishlistInit);
    }
})();